import _ from 'lodash';

const dateMapper = (value: any, key: string) => {
	/** re-typed form data: "date string" to "Date object" type */
	if ((key.endsWith('Date') || key.endsWith('Dat') || key.endsWith('DatOd') || key.endsWith('DatDo')) && value) {
		const dateVal = new Date(value);
		if (!Number.isNaN(<any>dateVal)) { return dateVal; }
		throw Error(`wrong date value: ${key}, ${value}`);
	}
	return value;
};

export const valueMapper = (value: any, key: string) => dateMapper(value, key);

export const dataMapper = (state: Object, data: Object) => _.assign(state, _.mapValues(data, valueMapper));
